import { extractRenderPropsChildren, RenderPropsChildren } from '../../../libs/renderProps'
import { Component } from 'preact'

import SearchBox from '../../../preact-components/search-box/SearchBox'

interface RenderProps<T> {
  items: T[] | undefined
  value: string
}

interface Props {
  items?: Array<{ name: string }>
  placeholder?: string
  children: RenderPropsChildren<RenderProps<any>>
  onClickSelectAll?: () => void
  selectionLabel?: string
}

interface State {
  value: string
}

class SearchableFilterSelector extends Component<Props, State> {
  state = { value: '' }

  render() {
    const { items, placeholder, children, onClickSelectAll, selectionLabel } = this.props
    const { value } = this.state

    const filteredItems = items?.filter((item) =>
      item.name.toLowerCase().includes(value.toLowerCase())
    )
    return (
      <div className='overview__filters-box-content'>
        <SearchBox
          isModerationOverview
          placeholder={placeholder}
          value={value}
          onSubmit={() => {}}
          onInput={(e) => this.setState({ value: (e.target as HTMLInputElement).value })}
          onClear={() => this.setState({ value: '' })}
        />
        {filteredItems && filteredItems.length === 0 && (
          <div className='overview__filters-box-content-no-results'>No results found</div>
        )}
        {filteredItems && filteredItems.length > 0 && (
          <p className='select-all' onClick={onClickSelectAll}>{selectionLabel}</p>
        )}
        {extractRenderPropsChildren(children)({ items: filteredItems, value })}
      </div>
    )
  }
}

export default SearchableFilterSelector
